import React from "react";

import { type GetOverviewPerformance_me_overviewPage_performanceMetrics as OverviewPageMetric } from "@north-beam/nb-client-side";
import { Select } from "@shared/selects";

interface MetricSelectProps {
  selectedMetric: OverviewPageMetric;
  metrics: OverviewPageMetric[];
  selectMetricIndex: (index: number) => void;
}

export const MetricSelect = ({
  selectedMetric,
  metrics,
  selectMetricIndex,
}: MetricSelectProps) => {
  if (metrics.length === 1) {
    return <div className="font-bold text-sm">{selectedMetric.name}</div>;
  }

  return (
    <Select
      className="metric-select"
      options={metrics.map((metric, index) => ({
        label: metric.name,
        value: index,
      }))}
      value={metrics.findIndex((metric) => metric.name === selectedMetric.name)}
      onChange={selectMetricIndex}
    />
  );
};
